import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=346c8f12"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=346c8f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports